import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Thu Jun 27 2019
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { DashboardTaskConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var TaskLayer =
/*#__PURE__*/
function () {
  function TaskLayer() {
    _classCallCheck(this, TaskLayer);
  }

  _createClass(TaskLayer, [{
    key: "getAll",

    /** Fetches all opened tasks for dashboard */
    value: function getAll() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.TASK_OPENED)).get();

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", (data.result || []).map(function (task) {
                  return _this.dashboardTaskConverter.toObject(task, jsonConversions);
                }));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                logger.error(_context.t0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));
    }
  }]);

  return TaskLayer;
}();

__decorate([Inject, __metadata("design:type", DashboardTaskConverter)], TaskLayer.prototype, "dashboardTaskConverter", void 0);